import React, { useRef, useState, FunctionComponent, PropsWithChildren } from 'react';
import useRowStyles from 'src/assets/css/components/RowComponentsStyles';
import 'src/styles.css'
import { ICommentActionsProps } from 'src/models/components/ICommentActions'
import ConfirmDialog from 'src/components/ConfirmDialog'
import { MoreVert } from '@material-ui/icons'
import { IconButton, Menu, MenuItem } from '@material-ui/core'
import Spinner from 'src/components/Spinner'

const CommentActions: FunctionComponent<ICommentActionsProps> = (props: PropsWithChildren<ICommentActionsProps>) => {

    const classes = useRowStyles();
    const menuAnchorEl = useRef<EventTarget & HTMLButtonElement>()
    const [isConfirmDialogOpen, setConfirmDialogOpen] = useState(false)
    const [isMenuOpen, setMenuOpen] = useState(false)

    const handleOpenMenu = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setMenuOpen(true)
        menuAnchorEl.current = e.currentTarget
    }
    const handleCloseMenu = () => setMenuOpen(false)

    const handleDelete = async () => {
      setConfirmDialogOpen(false)
      setMenuOpen(false)
      await props.handleDelete()
    }

    const handleEdit = () => {
      setMenuOpen(false)
      props.handleEdit()
    }

    const { comment } = props

    const iconButton = (
        <div>
            <IconButton
                className={classes.button}
                onClick={handleOpenMenu}
                data-testid='actions-menu'
                aria-label='More'
                title="More">
                <MoreVert className={classes.largeIcon} />
            </IconButton>
        </div>
    );

    const buttons = (
        <div className='inline-vertical-center'>
            {iconButton}
            <Menu
                className={classes.dropdownMenu}
                open={isMenuOpen}
                anchorEl={menuAnchorEl.current}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                onClose={handleCloseMenu}
            >
                {comment._links && comment._links['update comment'] != null && (
                  <MenuItem
                    className={classes.dropdownItem}
                    dense
                    onClick={handleEdit}
                  >
                    <i className='fas fa-edit' />
                    <span>Edit</span>
                  </MenuItem>)}
                {comment._links && comment._links['delete comment'] != null && (
                  <MenuItem
                    className={classes.dropdownItem}
                    dense
                    onClick={ () => setConfirmDialogOpen(true) }
                  >
                    <i className='fas fa-trash' />
                    <span>Delete</span>
                  </MenuItem>)}
            </Menu>
        </div>
    )

    const contextMenu = (
        <div className="rightSide_verticalDots">
            {(comment._links && comment._links['delete comment'] != null) ||
            (comment._links && comment._links['update comment'] != null)
              ? (
                <Spinner active={props.isLoading}>
                    {buttons}
                </Spinner>
                )
              : null}
        </div>
    )

    return (
        <>
            {contextMenu}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                title={`Delete comment?`}
                message="Remove this comment. This action cannot be undone."
                cancelLabel="Close"
                confirmLabel="Delete"
                handleClose={ () => setConfirmDialogOpen(false) }
                handleConfirm={ handleDelete } />
        </>
    )
}

export default CommentActions
